import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import cookieHelper from "helpers/getCookieData";
import LiveTimer from "helpers/live_timer"
import { useLocation } from "react-router-dom";

import { hasPermission, getUserRole, isAdminUser, isSuperAdminUser } from "helpers/permissionHelper";
import { isPaymentModuleEnabled, isMultiChairEnabled, isReportsEnabled } from "helpers/tenantModuleHelper";
import { getClinicSeoSlug } from "helpers/seoHelper";
import { RiExternalLinkLine, RiHospitalLine } from "react-icons/ri";
import TopNotificationBanner from "../CommonForBoth/TopBanner/TopNotificationBanner";

const Navbar = props => {
  const [clinic, setClinic] = useState(false);
  const [role, setRole] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  const showTimerRoutes = ["/appointment", "/chairs"];

  useEffect(() => {
    const authCookie = cookieHelper.getCookie("authUser") ? JSON.parse(cookieHelper.getCookie("authUser")) : null;
    const userRole = getUserRole();
    setRole(userRole);
    setIsAdmin(isAdminUser());

    const clinicCookie = cookieHelper.getCookie("_c");
    if (clinicCookie) {
      try {
        const parsedClinic = JSON.parse(atob(clinicCookie));
        setClinic(parsedClinic);
        if (parsedClinic?.id) {
          localStorage.setItem('clinic', parsedClinic.id);
        }
      } catch (e) {
        setClinic(null);
      }
    }
  }, []);

  const hiddenRoutes = ["/clinics", "/verify", "/clinic", "/book", "/portal"];
  if (hiddenRoutes.some(r => location.pathname.startsWith(r)) || role === 'patient') {
    return null;
  }

  if (clinic === false) {
    return null;
  }

  const clinicSlug = getClinicSeoSlug(clinic);

  return (
    <React.Fragment>
      <div className="topnav shadow-xs">
        <TopNotificationBanner />
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {role === 'patient' ? (
                  <>
                    <li className="nav-item">
                      <Link to="/portal" className="nav-link">
                        <i className="bx bx-home-circle me-2"></i> {props.t("Patient Dashboard") || "Patient Dashboard"}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/profile" className="nav-link">
                        <i className="bx bx-user me-2"></i> {props.t("My Profile") || "My Profile"}
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    {hasPermission('Chairs') && isMultiChairEnabled() && (
                      <li className="nav-item">
                        <Link to="/chairs" className="nav-link" > <i className="bx bx-table me-2"></i> {props.t("Chairs")}</Link>
                      </li>
                    )}
                    {hasPermission('Appointment') && (
                      <li className="nav-item">
                        <Link to="/appointment" className="nav-link" > <i className="bx bx-calendar-event me-2"></i> {props.t("Appointments")}</Link>
                      </li>
                    )}
                    {hasPermission('Patients') && (
                      <li className="nav-item">
                        <Link to="/patients" className="nav-link"><i className="bx bx-user me-2"></i> {props.t("Patients")} </Link>
                      </li>
                    )}
                    {hasPermission('Accounts') && isPaymentModuleEnabled() && (
                      <li className="nav-item">
                        <Link to="/accounts" className="nav-link"><i className="bx bx-money me-2"></i> {props.t("Accounts & Billing")} </Link>
                      </li>
                    )}
                    {hasPermission('Reports') && isReportsEnabled() && (
                      <li className="nav-item">
                        <Link to="/reports" className="nav-link" > <i className="bx bx-layer me-2"></i> {props.t("Reports")}</Link>
                      </li>
                    )}
                    {(isAdmin || isAdminUser()) && (
                      <li className="nav-item">
                        <Link to="/settings" className="nav-link" > <i className="bx bx-cog me-2"></i> {props.t("Settings & Roles")}</Link>
                      </li>
                    )}
                    {isSuperAdminUser() && (
                      <li className="nav-item">
                        <Link to="/superadmin" className="nav-link" > <i className="bx bx-shield-quarter me-2 text-warning"></i> {props.t("SuperAdmin Portal")}</Link>
                      </li>
                    )}
                  </>
                )}
              </ul>

              {/* Right Side: Public Landing Page & Online Booking Preview (Staff/Admin only) */}
              {clinic && role !== 'patient' && (
                <div className="ms-auto d-flex align-items-center gap-2 py-1">
                  <a
                    href={`/clinic/${clinicSlug}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm font-size-11 d-inline-flex align-items-center gap-1.5 shadow-2xs rounded-pill px-3 py-1 font-weight-semibold"
                    style={{ borderColor: 'rgba(248, 202, 21, 0.6)', color: '#F8CA15', backgroundColor: 'rgba(248, 202, 21, 0.1)', border: '1px solid rgba(248, 202, 21, 0.5)' }}
                    title="Open Clinic Public Landing Page & Online Booking"
                  >
                    <RiHospitalLine className="font-size-13" />
                    <span>Public Landing Page</span>
                    <RiExternalLinkLine className="font-size-11 opacity-75" />
                  </a>
                </div>
              )}
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
